import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DownloadFile, Icon, PrintFile, toast, BasicTooltip } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { Button,
// Checkbox,
TableCell, TableRow, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from '../styles';
export default function StatementTableRow(props) {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _props$row = props.row,
    row = _props$row === void 0 ? {} : _props$row,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    emailClicked = _useState2[0],
    setEmailClicked = _useState2[1];
  const sendPaperStatements = async data => {
    const resp = await store.statement.sendPaperStatementAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (!emailClicked) return;
    sendPaperStatements({
      paperStatementId: row.id
    }).then(() => toast('success', {
      body: ['The statement has been sent.']
    }) // ? i18n
    ).finally(() => setEmailClicked(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailClicked]);
  return /*#__PURE__*/React.createElement(TableRow, {
    className: "".concat(isSelected ? classes.selectedRow : '')
  }, /*#__PURE__*/React.createElement(TableCell, null, row.unitName), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.cellXl
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, store.account.profilesFullName.get(row.accountId))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$", Number(row.chargesTotal).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$", Number(row.creditsTotal).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$", Number(row.utilityBillsTotal).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$", row.utilityCapsTotal > 0 ? Number(row.utilityCapsTotal * -1).toFixed(2) : Number(row.utilityCapsTotal).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$", row.statementCapsTotal > 0 ? Number(row.statementCapsTotal * -1).toFixed(2) : Number(row.statementCapsTotal).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$", Number(row.total).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: !store.account.profilesEmailValue.get(row.accountId) && !store.account.profilesNewEmailValue.get(row.accountId) ? 'Resident has no email' : t('general.send_statement'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.wrappedTooltip
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setEmailClicked(true),
    size: "small",
    variant: "actionIcon",
    disabled: !store.account.profilesEmailValue.get(row.accountId) && !store.account.profilesNewEmailValue.get(row.accountId),
    'custom-attribute': '431-StatementsTable-row'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "mail-send"
  })))), /*#__PURE__*/React.createElement(PrintFile, {
    fileId: row.fileId,
    getUrlAsyncCallback: async () => {
      const resp = await store.files.getPresignedFileDownloadUrlAsync.run({
        fileId: row.fileId,
        isPreview: true
      });
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        return resp.response;
      }
    },
    href: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? null : "".concat(store.files.getFilePreviewLink({
      fileId: row.fileId
    })),
    showText: false,
    variant: "actionIcon",
    tooltipText: t('general.print_statement')
  }), /*#__PURE__*/React.createElement(DownloadFile, {
    fileId: row.fileId,
    usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
    showText: false,
    store: store,
    variant: "actionIcon",
    tooltipText: t('general.download_statement')
  }))));
}
StatementTableRow.propTypes = {
  handleRowSelection: PropTypes.func,
  isSelected: PropTypes.bool,
  row: PropTypes.shape({
    chargesTotal: PropTypes.number,
    creditsTotal: PropTypes.number,
    id: PropTypes.string,
    residencyId: PropTypes.string,
    unitName: PropTypes.string,
    utilityBillsTotal: PropTypes.number,
    utilityCapsTotal: PropTypes.number
  })
};